export default __webpack_public_path__ + "static/media/internBlack.72735dee.svg";